import React, { useState, useEffect } from 'react';
import ProductList from './ProductList';
import { useParams } from 'react-router-dom';
import Navigation from './Navigation';
import Filters from './Filters';
import Order from './Order';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { setTableNrCookie } from './CookieService';
import MenuService from './MenuService';

const Table = () => {
    const { paramTableNumber } = useParams();
    const [tableNumber, setTableNumber] = useState(paramTableNumber);
    const [tmpTableNumber, setTmpTableNumber] = useState(null);
    const [isShopOpen, setIsShopOpen] = useState(true);
    const [order, setOrder] = useState({ orderLines: [], extraGlasses: 0, email: "", tableNumber: tableNumber });
    const [filterTxt, setFilterTxt] = useState("");
    const [filterCategory, setFilterCategory] = useState("");
    const [filterColor, setFilterColor] = useState("");
    const [menuList, setMenuList] = useState([]);

    useEffect(() => {

        setTableNrCookie(tableNumber);

        const menuService = new MenuService();
        menuService.checkShopStatus().then(data => {
            setIsShopOpen(data);
        });

        menuService.getMenuItems().then(data => {
            setMenuList(data);
        });

    }, [tableNumber]);

    const handleUpdateTableNumber = async (event) => {
        console.log("updating table number")

        event.preventDefault();
        setTableNumber(tmpTableNumber);
        setTableNrCookie(tmpTableNumber);
    }

    const addProduct = function (product) {
        const cpOrder = JSON.parse(JSON.stringify(order));

        for (var i = 0; i < cpOrder.orderLines.length; i++) {
            if (cpOrder.orderLines[i].productId === product.productNumber) {
                cpOrder.orderLines[i].quantity++;
                toast.success("'" + product.productName + "' succesvol toegevoegd aan bestelling.", { autoClose: 750 });
                setOrder(cpOrder);
                console.log(cpOrder);
                return;
            }
        }

        // check if total lines does not exceed 12
        if (cpOrder.orderLines.length > 11) {
            toast.error("Maximum aantal bestelregels bereikt. Gelieve de bestelling door te sturen en de resterende producten in een nieuwe bestelling te plaatsen.");
            return;
        }

        cpOrder.orderLines.push(
            {
                quantity: 1,
                productId: product.productNumber,
                product: product
            }
        );
        setOrder(cpOrder);
        toast.success("'" + product.productName + "' succesvol toegevoegd aan bestelling.", { autoClose: 750 });
    };

    const handleAddToOrder = (product) => {
        addProduct(product);
    };

    const handleRemoveProduct = (index) => {
        const cpOrder = JSON.parse(JSON.stringify(order));
        cpOrder.orderLines.splice(index, 1);
        setOrder(cpOrder);
    };

    const handleQuantityChange = (index, quantity) => {
        const cpOrder = JSON.parse(JSON.stringify(order));
        cpOrder.orderLines[index].quantity = quantity;
        setOrder(cpOrder);
    }

    const handleExtraGlassesChange = (quantity) => {
        const cpOrder = JSON.parse(JSON.stringify(order));
        cpOrder.extraGlasses = quantity;
        setOrder(cpOrder);
    }

    const handleSubmitOrder = async (order) => {
        order.tableNumber = tableNumber;
        new MenuService().saveOrder(order).then(data => {
            if (data) {
                toast.success(`Bestelling met nummer ${data.id} succesvol verstuurd!`, { autoClose: 3000 });
                setOrder({ orderLines: [], extraGlasses: 0, email: "", tableNumber: tableNumber });
            } else {
                toast.error('Er is iets misgegaan bij het versturen van de bestelling. Probeer nogmaals.', { autoClose: 5000 });
            }
        });
    }

    return (
        <div className="container-xxl">
            {tableNumber ? (
                <div className='shopOpen'>
                    {isShopOpen ? (

                        <div>
                            <Navigation title={"Bestel voor tafel " + tableNumber} activeItem="bestel" />
                            <Order order={order} handleRemoveProduct={handleRemoveProduct} handleQuantityChange={handleQuantityChange} handleExtraGlassesChange={handleExtraGlassesChange} handleSubmitOrder={handleSubmitOrder} />
                            <Filters toFilter={menuList} handleSetFilterTxt={setFilterTxt} filterTxt={filterTxt} handleSetFilterCat={setFilterCategory} filterCategory={filterCategory} handleSetFilterColor={setFilterColor} filterColor={filterColor} />
                            <ProductList menuList={menuList} handleAddToOrder={handleAddToOrder} filterTxt={filterTxt} filterCategory={filterCategory} filterColor={filterColor} />
                        </div>

                    )

                        : (
                            <div className='shopClosed'>
                                <h1>Bestellen is nu even niet mogelijk ... </h1>
                            </div>
                        )}
                </div>) : (
                <div className="container mt-5">
                    <form onSubmit={handleUpdateTableNumber} className="form-inline">
                        <div className='form-group mb-2'>
                            <label>Tafelnummer: </label>
                            <input type="text" className="form-control" value={tableNumber} onChange={(e) => setTmpTableNumber(e.target.value)} />
                        </div>
                        <button type="submit" className="btn btn-primary mb-2">
                            Enter
                        </button>
                    </form>
                </div>
            )}
            <ToastContainer />
        </div>
    );
};

export default Table;